import { AccountContactDTO } from './dtos/account-contact.dto';

export class AccountContact implements IContactPermissions {
  constructor(
    public acCode: string,
    public lcAuto: number,
    public salutation: string,
    public firstName: string,
    public lastName: string,
    public positionHeld: string,
    public isRegulatoryContact: boolean,
    public isSQUContact: boolean,
    public isDirector: boolean,
    public addressLine1: string,
    public addressLine2: string,
    public addressLine3: string,
    public addressLine4: string,
    public postCode: string,
    public county: string,
    public country: string,
    public phone: string,
    public mobile: string,
    public fax: string,
    public email: string,
    public hasOnlineAccess: boolean,
    public hasActiveLicences: boolean,
    public accountPermissions: number,
    public roleId: number
  ) {}

  static fromDto(dto: AccountContactDTO): AccountContact {
    const company = new AccountContact(
      dto.acCode,
      dto.lcAuto,
      dto.salutation,
      dto.firstName,
      dto.lastName,
      dto.positionHeld,
      dto.isRegulatoryContact,
      dto.isSQUContact,
      dto.isDirector,
      dto.addressLine1,
      dto.addressLine2,
      dto.addressLine3,
      dto.addressLine4,
      dto.postCode,
      dto.county,
      dto.country,
      dto.phone,
      dto.mobile,
      dto.fax,
      dto.email,
      dto.hasOnlineAccess,
      dto.hasActiveLicences,
      dto.accountPermissions,
      dto.roleId
    );

    return company;
  }

  convertToDto(): AccountContactDTO {
    const dto: AccountContactDTO = {
      acCode: this.acCode,
      lcAuto: this.lcAuto,
      salutation: this.salutation,
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      addressLine1: this.addressLine1,
      addressLine2: this.addressLine2,
      addressLine3: this.addressLine3,
      addressLine4: this.addressLine4,
      postCode: this.postCode,
      county: this.county,
      country: this.country,
      phone: this.phone,
      mobile: this.mobile,
      fax: this.fax,
      positionHeld: this.positionHeld,
      isRegulatoryContact: this.isRegulatoryContact,
      isSQUContact: this.isSQUContact,
      isDirector: this.isDirector,
      hasOnlineAccess: this.hasOnlineAccess,
      hasActiveLicences: this.hasActiveLicences,
      accountPermissions: this.accountPermissions,
      roleId: this.roleId
    };

    return dto;
  }
}

export interface IContactPermissions {
  email: string;
  accountPermissions: number;
}
